import { AppointmentMoment } from "../shared/appointment-moment";

export class CreateAppointmentRequest {
  constructor(  
  public name: string,
  public phone: string,
  public email: string,
  public moment: AppointmentMoment,
  public hairdresser: string,
  public longHair: boolean,
  public highlights: boolean,
  public serviceName: string)
  {}
}

export class CreateAppointmentResult {
  public appointmentId: string;
}

